import { render, staticRenderFns } from "./TicketsAmend.vue?vue&type=template&id=457132c8&"
import script from "./TicketsAmend.vue?vue&type=script&lang=js&"
export * from "./TicketsAmend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports